import { useMemo } from "react";
import PCNewsCard from "./PCNewsCard";
import PCThemeWidget from "./PCThemeWidget";
import PCFilterBar from "./PCFilterBar";
import PCRightPanel from "./PCRightPanel";

function TierRule() {
  return (
    <div style={{ padding: "4px 28px 0" }}>
      <div style={{ borderTop: "2px solid rgba(255,255,255,.6)" }} />
    </div>
  );
}

export default function PCNewsTab({
  news, themes, byTier,
  socmint, adversary,
  selected, onSelect,
  filters, setFilters,
  onOverride, onLoad,
}) {
  // Apply filters
  const filtered = useMemo(() => {
    let list = news;
    if (filters.tier.size > 0) list = list.filter(a => filters.tier.has(a.cls));
    if (filters.dir.size > 0)  list = list.filter(a => a.dir && filters.dir.has(a.dir));
    if (filters.sort === "time") {
      list = [...list].sort((p, q) => new Date(q.publishedAt) - new Date(p.publishedAt));
    }
    return list;
  }, [filters, news]);

  const isFlat = filters.sort === "time";

  // 시간순일 때는 flat. 중요도순은 tier 섹션.
  const tierBuckets = useMemo(() => {
    if (isFlat) return null;
    if (filters.tier.size > 0) {
      // tier 필터 있으면 flat
      return null;
    }
    return {
      gun:       filtered.filter(a => a.cls === "gun"),
      watershed: filtered.filter(a => a.cls === "watershed"),
      notable:   filtered.filter(a => a.cls === "notable"),
      common:    filtered.filter(a => !a.cls || a.cls === "common"),
    };
  }, [filtered, isFlat, filters.tier]);

  // 적대국 매체 묶음 (RightPanel에 넘김)
  const adversaryArticles = [...adversary];

  return (
    <div style={{ flex: 1, display: "flex", overflow: "hidden", minHeight: 0 }}>
      {/* Center list */}
      <div style={{ flex: 1, overflowY: "auto", minWidth: 0 }}>
        {!isFlat && filters.tier.size === 0 && themes?.length > 0 && (
          <PCThemeWidget themes={themes} onSelect={onSelect} />
        )}

        <PCFilterBar filters={filters} setFilters={setFilters} />

        {tierBuckets ? (
          <>
            {tierBuckets.gun.length > 0 && (
              <>
                {tierBuckets.gun.map(a => (
                  <PCNewsCard key={a.id} article={a} selected={selected?.id === a.id} onClick={onSelect} onOverride={onOverride} />
                ))}
              </>
            )}
            {tierBuckets.watershed.length > 0 && (
              <>
                {tierBuckets.gun.length > 0 && <TierRule />}
                {tierBuckets.watershed.map(a => (
                  <PCNewsCard key={a.id} article={a} selected={selected?.id === a.id} onClick={onSelect} onOverride={onOverride} />
                ))}
              </>
            )}
            {tierBuckets.notable.length > 0 && (
              <>
                <TierRule />
                {tierBuckets.notable.map(a => (
                  <PCNewsCard key={a.id} article={a} selected={selected?.id === a.id} onClick={onSelect} onOverride={onOverride} />
                ))}
              </>
            )}
            {tierBuckets.common.length > 0 && (
              <>
                <TierRule />
                {tierBuckets.common.map(a => (
                  <PCNewsCard key={a.id} article={a} selected={selected?.id === a.id} onClick={onSelect} onOverride={onOverride} />
                ))}
              </>
            )}
          </>
        ) : (
          filtered.map(a => (
            <PCNewsCard key={a.id} article={a} selected={selected?.id === a.id} onClick={onSelect} onOverride={onOverride} />
          ))
        )}

        <div style={{ padding: "30px 24px 60px", textAlign: "center" }}>
          <button
            onClick={onLoad}
            style={{
              background: "none",
              border: "1px solid var(--pc-line-2)",
              color: "var(--pc-fg-3)",
              fontSize: 12,
              fontWeight: 600,
              letterSpacing: ".10em",
              padding: "10px 20px",
              cursor: "pointer",
              borderRadius: 0,
            }}
          >
            새로고침
          </button>
        </div>
      </div>

      {/* Right panel */}
      <PCRightPanel
        article={selected}
        allArticles={news}
        adversaryArticles={adversaryArticles}
        onSelect={onSelect}
      />
    </div>
  );
}
